import React from "react";
import "../../styles/profileAccordian.css"; // Import styles
import BankDetail from "../../components/Admin/ViewBankDetail";
import PersonelDetail from "../../components/Admin/ViewPersonelDetail";
import ManageNominees from "../../components/Admin/ViewNominees";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
// import FatcaDeclaration from "./FatcaDeclaration";

const MyProfileAccordian = ({ data }) => {
  console.log("data",data)
  const navigate = useNavigate();
  return (
    <div className="accordion profile_accordian my-lg-3" id="accordionExample">
      {/* <Link style={{marginBottom: "8px",marginTop: "3px"}} onClick={()=>navigate(-1)}>
        <FontAwesomeIcon
          icon={faAngleLeft}
          className="color me-2"
          style={{ fontSize: "24px", color: "#000", paddingRight: "10px" }}
        />
      </Link> */}
      <div style={{ display: "flex" }}>
        <Link
          style={{ marginBottom: "8px", marginTop: "3px" }}
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon
            icon={faAngleLeft}
            className="color me-2"
            style={{ fontSize: "24px", color: "#2C2D3A", paddingRight: "10px" }}
          />
        </Link>
        <h5 className="mb-4 main-heading-title">Profile</h5>
      </div>

      <PersonelDetail data={data} />

      <BankDetail data={data} />

      <ManageNominees data={data} />
    </div>
  );
};

export default MyProfileAccordian;
